import { Component, HostListener, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-back-to-top',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './back-to-top.component.html',
  styleUrl: './back-to-top.component.scss'
})
export class BackToTopComponent implements OnInit {
  isVisible = false;
  scrollProgress = 0;
  private readonly isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) platformId: object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit() {
    this.updateScrollProgress();
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.updateScrollProgress();
  }

  private updateScrollProgress() {
    if (!this.isBrowser) return;
    
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollable =
      document.documentElement.scrollHeight - document.documentElement.clientHeight;

    // Show button after scrolling 300px
    this.isVisible = scrollTop > 300;

    // Scroll percentage (avoid NaN when the page is not scrollable)
    const denom = Math.max(1, scrollable);
    this.scrollProgress = Math.min(100, (scrollTop / denom) * 100);
  }

  scrollToTop() {
    if (this.isBrowser) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }

  get strokeDashoffset(): number {
    const circumference = 2 * Math.PI * 18; // radius = 18
    return circumference - (this.scrollProgress / 100) * circumference;
  }
}

